import { render, staticRenderFns } from "./personrecruit.vue?vue&type=template&id=610571a0&scoped=true"
import script from "./personrecruit.vue?vue&type=script&lang=js"
export * from "./personrecruit.vue?vue&type=script&lang=js"
import style0 from "./personrecruit.vue?vue&type=style&index=0&id=610571a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610571a0",
  null
  
)

export default component.exports